import { Integration } from "../../advanced-flow/integrations";
import { SchemaField } from "../../advanced-flow/type-system/schema";

/**
 * These are variables that are not part of the schema, but are used in email and SMS templates
 * They are used to reference data from the customer event
 * WARNING: Do not overlap naming with schema variables
 */
export enum NonSchemaReferenceVariableName {
  MOST_RECENTLY_VIEWED_PRODUCT_LINK = "mostRecentlyViewedProductLink",
  MOST_RECENTLY_VIEWED_PRODUCT_NAME = "mostRecentlyViewedProductName",
  REP_NAME = "repName",
  BRAND_NAME = "brandName",
  SUPPORT_EMAIL = "supportEmail",
  CUSTOMER_LOYALTY_LION_POINTS = "customerLoyaltyLionPoints",
}

export function isNonSchemaReferenceVariableName(
  variableName: string,
): variableName is NonSchemaReferenceVariableName {
  return Object.values(NonSchemaReferenceVariableName).includes(
    variableName as NonSchemaReferenceVariableName,
  );
}

export const NonSchemaReferenceVariable: Record<
  NonSchemaReferenceVariableName,
  SchemaField
> = {
  [NonSchemaReferenceVariableName.MOST_RECENTLY_VIEWED_PRODUCT_LINK]: {
    key: NonSchemaReferenceVariableName.MOST_RECENTLY_VIEWED_PRODUCT_LINK,
    dataType: "Url",
    documentation: "The link to the most recently viewed product",
  },
  [NonSchemaReferenceVariableName.MOST_RECENTLY_VIEWED_PRODUCT_NAME]: {
    key: NonSchemaReferenceVariableName.MOST_RECENTLY_VIEWED_PRODUCT_NAME,
    dataType: "Text",
    documentation: "The name of the most recently viewed product",
  },
  [NonSchemaReferenceVariableName.REP_NAME]: {
    key: NonSchemaReferenceVariableName.REP_NAME,
    dataType: "Text",
    documentation: "The name of the representative (for RECOVER messages)",
  },
  [NonSchemaReferenceVariableName.BRAND_NAME]: {
    key: NonSchemaReferenceVariableName.BRAND_NAME,
    dataType: "Text",
    documentation: "The brand/store name",
  },
  [NonSchemaReferenceVariableName.SUPPORT_EMAIL]: {
    key: NonSchemaReferenceVariableName.SUPPORT_EMAIL,
    dataType: "Text",
    documentation: "The support email address for customer inquiries",
  },
  [NonSchemaReferenceVariableName.CUSTOMER_LOYALTY_LION_POINTS]: {
    key: NonSchemaReferenceVariableName.CUSTOMER_LOYALTY_LION_POINTS,
    dataType: "Maybe Number",
    documentation: "The loyalty points of the customer",
    shouldInclude: (integrations) =>
      integrations[Integration.LOYALTY_LION] === true,
  },
};
